import { render, staticRenderFns } from "./CheckoutOverlay.vue?vue&type=template&id=20edc184&scoped=true&"
import script from "./CheckoutOverlay.vue?vue&type=script&lang=js&"
export * from "./CheckoutOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutOverlay.vue?vue&type=style&index=0&id=20edc184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20edc184",
  null
  
)

export default component.exports